export default {
  Title: 'Career Highlights',
  YoE: 'Years of Experience',
  ClientSatisfaction: 'Client Satisfaction',
};
